import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { UploadService } from '../../services/upload.service';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { GLOBAL } from '../../services/global';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css'],
  providers: [UserService, UploadService]
})
export class MyProfileComponent implements OnInit {
  public user: User;
  public status: string;
  public identity;
  public tokken;
  public message: string;
  public filesToUpload: Array<File>;
  public url: string;
  public rndmKey: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private uploadService: UploadService
  ) { 
    this.user = this.userService.getIdentity();
    this.tokken = this.userService.getToken();
    this.filesToUpload = [];
    this.url = GLOBAL.url;
    this.rndmKey = this.userService.generateRandomString(10);
  }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */
  }


  onSubmit(form) {
    this.userService.saveProfile(this.user).subscribe(
      response => {
        console.log(response);
        this.message = response.message;
        if (response.status) {
          this.status = 'success';
          localStorage.setItem('identity', JSON.stringify(response.identity));
          this.user = this.userService.getIdentity();

          let noFiles = this.filesToUpload.length;
          console.log(noFiles);

          if (noFiles > 0) {
            console.log('Subiendo avatar');
            this.uploadService.makeFileRequest('update/my/avatar', [], this.filesToUpload, this.tokken, 'avatar').then(
              (result: any) => {
                console.log('log');
                console.log(result);
                console.log('log');

                if (result.status) {
                  this.message = 'Su información e imagen de usuario se actualizo correctamente';
                  this.status = 'success';
                  localStorage.setItem('identity', JSON.stringify(result.identity));
                  this.user = this.userService.getIdentity();
                  this.rndmKey = this.userService.generateRandomString(10);
                  localStorage.setItem('avatar_random', this.rndmKey);
                  /*localStorage.setItem('identity', JSON.stringify(result.identity));
                  this.user = result.identity;*/
                } else {
                  this.message = result.message;
                }
              }, ( reject ) => {
                console.log('Rechazado');
                console.log(reject);
                console.log('Rechazado');
              }
            );

          }




        } else {
          this.status = 'error';
        }
      }, error => {
        this.message = 'No se pudo procesar su solicitud en este momento [500]';
        this.status = 'error';
        console.log(error as any);
      }
    );


  }


  fileChangeEvent(fileInput: any) {
    this.filesToUpload = fileInput.target.files as Array<File>;
    console.log(this.filesToUpload);
  }

}
